import { FileServiceError } from "./FileServiceError";

export class FileServiceMaxSizeError extends FileServiceError {
  readonly maxSize: number;
  readonly fileSize?: number;

  constructor(message: string, maxSize: number, fileSize?: number) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "FileServiceMaxSizeError";
    this.maxSize = maxSize;
    this.fileSize = fileSize;
  }
}
